module.exports = __webpack_public_path__ + "img/LBA-CRM.1fa93c3d.svg";